// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"d1a05c14","238":"2b5b41b0","686":"539e7bc1"}[chunkId] + ".chunk.js";
};